// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.project-ready-task-row {
  position: relative;
  display: flex;
  align-items: start;
  gap: 12px;
  padding: 8px 12px;
  border-radius: 4px;
  min-height: 40px;
  justify-content: space-between;
}

.project-ready-task-row:hover {
  background-color: var(--neutral-50);
}

.project-ready-task-description {
  font-size: 14px;
  color: var(--neutral-900);
  line-height: 1.5;
}

.project-ready-task-assigned-user {
  font-size: 12px;
  color: var(--neutral-600);
  line-height: 1.4;
}

.project-ready-task-row.is-completed .project-ready-task-description,
.project-ready-task-row.is-completed .project-ready-task-assigned-user {
  text-decoration: line-through;
  color: var(--neutral-600);
}

.project-ready-task-edit-btn {
  visibility: hidden;
}

.project-ready-task-row:hover .project-ready-task-edit-btn,
.project-ready-task-row:focus-within .project-ready-task-edit-btn {
  visibility: visible;
}
`, "",{"version":3,"sources":["webpack://./src/frontend/components/projects/ProjectReadyTaskList.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,aAAa;EACb,kBAAkB;EAClB,SAAS;EACT,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,8BAA8B;AAChC;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;;EAEE,6BAA6B;EAC7B,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;EAEE,mBAAmB;AACrB","sourcesContent":[".project-ready-task-row {\n  position: relative;\n  display: flex;\n  align-items: start;\n  gap: 12px;\n  padding: 8px 12px;\n  border-radius: 4px;\n  min-height: 40px;\n  justify-content: space-between;\n}\n\n.project-ready-task-row:hover {\n  background-color: var(--neutral-50);\n}\n\n.project-ready-task-description {\n  font-size: 14px;\n  color: var(--neutral-900);\n  line-height: 1.5;\n}\n\n.project-ready-task-assigned-user {\n  font-size: 12px;\n  color: var(--neutral-600);\n  line-height: 1.4;\n}\n\n.project-ready-task-row.is-completed .project-ready-task-description,\n.project-ready-task-row.is-completed .project-ready-task-assigned-user {\n  text-decoration: line-through;\n  color: var(--neutral-600);\n}\n\n.project-ready-task-edit-btn {\n  visibility: hidden;\n}\n\n.project-ready-task-row:hover .project-ready-task-edit-btn,\n.project-ready-task-row:focus-within .project-ready-task-edit-btn {\n  visibility: visible;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
